enum InputModeEnum {
	// Keyboard for letters and numbers - no special characters.
	text = 'text',
	// Keypad for number inputs with decimals.
	decimal = 'decimal',
	// Keypad for number inputs without decimals.
	numeric = 'numeric',
	// Keypad for phone number inputs, including plus sign.
	tel = 'tel',
	// Keyboard for search inputs - same keyboard layout as text.
	search = 'search',
	// Keyboard for email inputs, including at sign, period, underscore, and dash.
	email = 'email',
	// Keyboard for URL inputs - same keyboard layout as text.
	url = 'url',
	// Keyboard for measurement inputs, including prime symbols, slash, and decimals.
	measurement = 'measurement'
}

export default InputModeEnum;
